// extracted by mini-css-extract-plugin
export var attachment = "_mo-a";
export var emailContainer = "_mo-4";
export var emailContentPaddedContainer = "_mo-b";
export var emailHeader = "_mo-6";
export var emailIframe = "_mo-3";
export var emailInfoIcon = "_mo-9";
export var emailShortenedSummary = "_mo-e";
export var infoDropdown = "_mo-0";
export var infoRowBoundedContent = "_mo-d";
export var internal = "_mo-5";
export var merchant = "_mo-8";
export var messageInputContainer = "_mo-h";
export var normal = "_mo-7";
export var replyCard = "_mo-f";
export var subtleButton = "_mo-1";
export var subtleButtonIconContainer = "_mo-2";
export var toggleViewRepliesButton = "_mo-c";
export var wrappingText = "_mo-g";